import { useForm } from "react-hook-form";
import { userService } from "../../service/User/user.service";
import UserForm from "./_userForm";
import { IUserCreateProps, IUserFormInput } from "./User.model";

const UserCreate = ({ setUserDialog, loadUsers }: IUserCreateProps) => {
  const methods = useForm<IUserFormInput>({
    defaultValues: {
      username: "",
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      is_active: true,
      is_staff: false,
      is_superuser: false,
      group_id: null,
    },
  });

  const { setError } = methods;

  const onSubmit = async (data: IUserFormInput) => {
    try {
      await userService.create(data);
      loadUsers();
      setUserDialog(false);
    } catch (err: any) {
      if (err.response?.data) {
        const errors = err.response.data;

        Object.keys(errors).forEach((key) => {
          setError(key as keyof IUserFormInput, {
            type: "server",
            message: Array.isArray(errors[key]) ? errors[key][0] : errors[key],
          });
        });
      }
    }
  };

  return <UserForm methods={methods} onSubmit={onSubmit} isEdit={false} />;
};

export default UserCreate;
